export default ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
    return {
        autofillBasedOnAdddress: function autofillBasedOnAdddress(address) {
            var deferred = $q.defer();
            JsonRPCService.send('addressLookup', 'lookup', 'lookupAddressUsingString', [address]).then(function (addressResult) {
                return deferred.resolve(addressResult);
            }, function (error, status, headers) {
                return deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        },
        autofillBasedOnPostalCode: function autofillBasedOnPostalCode(address) {
            var deferred = $q.defer();
            JsonRPCService.send('addressLookup', 'lookup', 'lookupAddressUsingObject', [address]).then(function (addressResult) {
                return deferred.resolve(addressResult);
            }, function (error, status, headers) {
                return deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/addresslookup/service/AddressLookupService.js
// module id = 1322
// module chunks = 0